import { render, staticRenderFns } from "./BaseEditorPdf.vue?vue&type=template&id=d0a5f686&scoped=true&"
import script from "./BaseEditorPdf.vue?vue&type=script&lang=js&"
export * from "./BaseEditorPdf.vue?vue&type=script&lang=js&"
import style0 from "./BaseEditorPdf.vue?vue&type=style&index=0&id=d0a5f686&prod&lang=css&"
import style1 from "./BaseEditorPdf.vue?vue&type=style&index=1&id=d0a5f686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a5f686",
  null
  
)

export default component.exports